import React from 'react';
import { message } from '@tencent/spaui';
import store, { useTypedSelector } from 'store/index';
import { DialogProps, showDialog } from 'components/dialog';
import './index.scss';
import AppAuthDialog from 'components/auth/appAuthDialog';
import AuthDialog from 'components/auth/authDialog';
import DetailDialog from './detailDialog';
import { report } from 'store/report';
import Tooltip from 'components/tooltip';

// 开放访问的角色
const legalRoles = [1, 3, 6, 10, 100, 101, 104, 108, 109, 114];

/**
 * 预校验
 */
export const preCheck = () => {
  const { user, roles } = store.getState().user;

  // 1. 是否登录
  if (!user) {
    location.href = `https://sso.e.qq.com/login/hub?sso_redirect_uri=${encodeURI(location.href)}&service_tag=80`;
    return;
  }

  // 2. 是否可访问
  if (roles?.every((item) => !legalRoles.includes(item))) {
    // message.warn('本工具暂未开放当前账户角色的访问，如有需求请联系AD_ISV@tencent.com');
    message.warn({
      duration: 0,
      message: '无可用账号信息，请前往投放后台（ad.qq.com）关联或者注册广告账号。',
      closable: true,
    });
    return;
  }

  return true;
};

export const useAuthorized = (id: string) => {
  const { myApp, roles, user } = useTypedSelector((state) => state.user);

  return {
    authorized: !!myApp?.find(({ client_id }) => id === client_id)?.authorize_status,
    accessPrivilege: roles?.some((item) => legalRoles.includes(item)),
    authPrivilege: roles?.includes(10) || roles?.includes(100) || user?.auto_activation_authed_status,
  };
};

export const showDetail = (id: string, name: string) => {
  if (preCheck()) {
    const { roles } = store.getState().user;
    const authPrivilege = roles?.includes(10) || roles?.includes(100);
    // 通过是否由权限来区分 开通详情/申请开通
    report({ event: authPrivilege ? 'auth-detail' : 'auth-apply', client_id: id });

    showDialog({
      className: 'auth-detail-dialog',
      title: `${name} - 开通详情`,
      content: <DetailDialog id={id} />,
    });
  }
};

/**
 * 开通授权
 * @param id
 */
export const showAuth = (id: string) => {
  if (preCheck()) {
    report({ event: 'auth', client_id: id });
    showDialog({
      className: 'auth-dialog',
      title: (
        <Tooltip popover="开通维度为服务商ID/直客ID；其中服务商ID开通后，所有关联的子客广告主ID将获得该应用的使用权限">
          应用开通
        </Tooltip>
      ),
      content: <AuthDialog id={id} />,
    });
  }
};

/**
 * 应用授权
 * @param id
 * @param dialogProps
 * @param url
 * @param newWin
 */
export const showAppAuth = (id: string, dialogProps?: Partial<DialogProps>, url?: string, newWin = true) => {
  report({ event: 'app-auth', client_id: id });
  showDialog({
    className: 'app-auth-dialog',
    title: '应用授权',
    content: <AppAuthDialog id={id} url={url} newWin={newWin} />,
    ...dialogProps,
  });
};
